import React from 'react'
import AppDialog from 'components/AppDialog'
import { default as AppMessage } from 'components/AppMessage'
import { message, Icon } from 'antd'
import api, { AppModuleGroup } from 'api'
import AppPopover from 'components/AppPopover'
import ModuleNewModuleIcon from './ModuleNewModuleIcon'

interface Props {
	mode: number
	afterSave?: () => void
	appModuleGroup: AppModuleGroup
}
// 一级模块
export default class ModuleGroupEdit extends React.Component<Props> {
	state = {
		moduleIcon: this.props.appModuleGroup.icon || '',
	}
	saveFormData = async () => {
		let appModuleGroup: AppModuleGroup = {} // this.refForm.current.getData()
		if (!appModuleGroup) return
		if (this.state.moduleIcon === '') {
			message.warn('请录入带*号的必填项')
			return
		}
		appModuleGroup.icon = this.state.moduleIcon

		let res = await api.modeling.module.saveModuleGroup(appModuleGroup)
		if (!res.result) {
			AppMessage.alark(res.msg)
			return
		} else {
			message.success('操作成功!')
			this.props.afterSave && this.props.afterSave()
		}

		AppDialog.close()
	}

	close = () => {
		AppDialog.close()
	}

	getModuleIcon = (e: any) => {
		// console.log(e.target.classList[0])
		this.setState({
			moduleIcon: e.target.classList[0],
		})
		AppPopover.close()
	}

	showIconList = (e: any) => {
		AppPopover.open(
			{
				target: e.target,
			},
			<ModuleNewModuleIcon getModuleIcon={this.getModuleIcon} currIcon={this.state.moduleIcon} />
		)
	}

	getSystemIcon = () => {
		return this.state.moduleIcon ? (
			<i
				className={this.state.moduleIcon}
				style={{
					fontSize: '18px',
					width: '30px',
					height: '30px',
					cursor: 'pointer',
					color: '#34a6f8',
				}}
				onClick={this.showIconList}
			/>
		) : (
			<Icon type="plus-circle" style={{ cursor: 'pointer' }} onClick={this.showIconList} />
		)
	}

	render() {
		let formData = this.props.appModuleGroup
		return (
			<div className="app-dialog-form-container">
				{/* <div className="app-dialog-form">
          <AppForm
            formStyle={{ width: '100%' }}
            ref={this.refForm}
            defaultData={formData}
            labelWidth={80}
          >
            <AppInput
              label="模块名称"
              field="name"
              placeholder="请输入模块名称"
              value = {formData.name}
              req
            />
            <AppInput
              label="应用编码"
              value = {formData.code}
              field="code"
              placeholder="请输入2位编码, 例如: 01"
              headerDescrip = {formData.application}
              disabled={this.props.mode===2 ? true : false}
              req
            />
            <AppInput
             label="排序编码"
             value = {formData.sort}
              field="sort"
              placeholder="建议与应用编码一致,例如：0001"
              req
            />
            <AppLabel
              label="模块图标"
              req
              render={this.getSystemIcon}
            />
          </AppForm>
        </div>
        <AppFormMenu>
          <AppAction title="取消" type="default" action={() => this.close()} />
          <AppAction
            title="确定"
            type="primary"
            action={() => this.saveFormData()}
          />
        </AppFormMenu> */}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/module/ModuleGroupEdit.tsx